import React from 'react';
import {Trans} from 'react-i18next';
import Modal from '../../../components/Modal';
import {modalContentStyle, Content} from './styled';

type LearnMoreModalProps = {
  isOpenPaidModal: boolean;
  handleCloseModal: () => void;
};
const LearnMoreModal = React.memo(
  ({isOpenPaidModal, handleCloseModal}: LearnMoreModalProps) => {
    return (
      <Modal
        open={isOpenPaidModal}
        onClose={handleCloseModal}
        contentStyle={modalContentStyle}
        closeOnDocumentClick
        closeOnEscape
        withCloseButton
      >
        <Content>
          <Trans i18nKey={'learn_more_security_deposit_description'}>
            <h3>How does it work?</h3>
            <ul>
              <li>
                Pay the deposit amount with a credit or debit card. The payment is really
                a pre-authorization for your bank to temporary block the amount but it
                won't charge it.
              </li>
              <li>
                Every 7 days the pre-authorization is released back to your account and
                automatically renewed up to 30 days or 7 days after the check-out date,
                whichever comes first. Depending on the length of your reservation you
                might get a couple of notifications from your bank with the
                pre-authorization renewal notice.
              </li>
              <li>
                After the 7 days of last pre-authorization, the amount will be completely
                released and available in your bank account.
              </li>
            </ul>
            <br />
            <h3>What if damage occurs?</h3>
            <ul>
              <li>
                Your host has up to 7 days after the check-out date of your reservation to
                review for damage.
              </li>
              <li>
                During that period if the accommodation terms were broken or the property
                assets were damaged, your host could charge the deposit amount as a
                penalty. If 7 days have passed after the check-out, your host won't be
                able to charge the amount anymore.
              </li>
            </ul>
          </Trans>
        </Content>
      </Modal>
    );
  },
);

export {LearnMoreModal};
